import { AppDispatch } from '~/reducers';
import type { RegionCodesResponse } from '~/types/types';
import ApiService from '~/util/apiService';
import Logger from '~/util/logger';

import { REQUESTING_REGION_CODES, RECEIVED_REGION_CODES } from './types/addressActionTypes';
import type { RegionCodeActionTypes } from './types/addressActionTypes';

const requestingRegionCodes = (): RegionCodeActionTypes => ({
  type: REQUESTING_REGION_CODES,
});

const receivedRegionCodes = (data: RegionCodesResponse): RegionCodeActionTypes => ({
  type: RECEIVED_REGION_CODES,
  payload: data,
});

export const fetchRegionCodes = () => (dispatch: AppDispatch) => {
  dispatch(requestingRegionCodes());
  return ApiService.get('/web-marketplace-api/v1/address/region-codes')
    .then((data: RegionCodesResponse) => {
      dispatch(receivedRegionCodes(data));
      return data;
    })
    .catch((error: Error) => {
      Logger.error(error);
      return null;
    });
};
